import React from "react"
import PropTypes from "prop-types"
import GridContainer from "../../../components/layouts/containers/GridContainer.container"
import GridItem from "../../../components/layouts/containers/GridItem.container"
import Divider from "../../../components/atoms/Divider.atom"
import { ValueWithLabelTemplate } from "../../../components/layouts/containers/ValueWithLabelElements.container"
import VacationDayTypesBreakdown from "./VacationDayTypesBreakdown.molecule"
import {
  getVacationRangeLabel,
  isForeignSchema,
  isVacationRequestCanceled,
} from "../../../utils/vacation.utils"
import { VACATION_APPROVED_STATUS } from "../../../consts/modules/vacations.consts"
import { DateTime } from "luxon"

const VacationMyRequestSummary = ({ vacationRequest }) => {
  return (
    <GridContainer className="vacation-request-summary">
      <GridItem
        col={
          (
            vacationRequest.numberOfPlusDays === 0 &&
            vacationRequest.approved !== VACATION_APPROVED_STATUS.NOT_REVIEWED
          ) ?
            12
          : 6
        }
        className="col-top-data"
      >
        <ValueWithLabelTemplate
          label={
            (
              vacationRequest.approved === VACATION_APPROVED_STATUS.REJECTED ||
              vacationRequest.approved ===
                VACATION_APPROVED_STATUS.CANCELED_BY_ADMIN ||
              vacationRequest.approved ===
                VACATION_APPROVED_STATUS.CANCELED_BY_TEAM_MEMBER
            ) ?
              "Fecha de rechazo"
            : "Fecha de aprobación"
          }
          value={
            vacationRequest.approved !== VACATION_APPROVED_STATUS.NOT_REVIEWED ?
              DateTime.fromISO(vacationRequest.approvedDate).toFormat(
                "dd/MM/yyyy"
              )
            : "Pendiente por aprobar"
          }
        />
      </GridItem>
      {(
        vacationRequest.numberOfPlusDays !== 0 &&
        vacationRequest.approved === VACATION_APPROVED_STATUS.APPROVED
      ) ?
        <GridItem col={6} className="col-top-data">
          {vacationRequest.plusDaysPayDate && (
            <ValueWithLabelTemplate
              label="Fecha de pago Días+"
              value={DateTime
                .fromISO(vacationRequest.plusDaysPayDate, { zone: "utc" })
                .toFormat("dd/MM/yyyy")}
            />
          )}
        </GridItem>
      : null}
      {vacationRequest.approved === VACATION_APPROVED_STATUS.REJECTED ?
        <GridItem col={6} className="col-top-data">
          <ValueWithLabelTemplate
            label="Razón del rechazo"
            value={vacationRequest.cancelationMotive}
          />
        </GridItem>
      : null}
      {isVacationRequestCanceled(vacationRequest) ?
        <GridItem col={6} className="col-top-data">
          <ValueWithLabelTemplate
            label="Razón de la cancelación"
            value={vacationRequest.cancelationMotive}
          />
        </GridItem>
      : null}
      <Divider stroke="sm" />
      <GridItem col={6}>
        <ValueWithLabelTemplate
          label="Fechas solicitadas"
          value={getVacationRangeLabel(
            vacationRequest.numberOfVacationDays,
            vacationRequest.startDate,
            vacationRequest.endDate,
            {
              includeNumberOfDays: false,
              includeDateRange: true,
              dateFormat: "dd/MM/yyyy",
            }
          )}
        />
      </GridItem>
      <GridItem col={6}>
        <ValueWithLabelTemplate
          label="Cantidad de días"
          value={
            <div className="flex gap-2">
              {vacationRequest?.numberOfVacationDays}
              <VacationDayTypesBreakdown vacationRequest={vacationRequest} />
            </div>
          }
        />
      </GridItem>
      <GridItem col={12}>
        <ValueWithLabelTemplate
          label="Motivo"
          value={vacationRequest.vacationsMotive}
        />
      </GridItem>
    </GridContainer>
  )
}

export default VacationMyRequestSummary

VacationMyRequestSummary.propTypes = {
  vacationRequest: PropTypes.shape({
    teamMember: PropTypes.shape({
      fullName: PropTypes.string.isRequired,
      idHolidaySchema: PropTypes.number.isRequired,
    }).isRequired,
    createdAt: PropTypes.string.isRequired,
    approved: PropTypes.number,
    approvedDate: PropTypes.string.isRequired,
    plusDaysPayDate: PropTypes.string,
    cancelationMotive: PropTypes.string,
    startDate: PropTypes.string.isRequired,
    endDate: PropTypes.string.isRequired,
    numberOfVacationDays: PropTypes.number.isRequired,
    vacationsMotive: PropTypes.string.isRequired,
  }).isRequired,
}
